import Section from '../../layout/Section';
import classes from './HistoryCollection.module.css';
import clsx from 'clsx';
import StandaloneBitstray from '../StandaloneBitstray';
import { LoadingBitstray } from '../Bitstray';
import config from '../../config';
import { Container, Row } from 'react-bootstrap';

interface HistoryCollectionProps {
  historyCount: number;
  latestBitstrayId: bigint;
}

const HistoryCollection: React.FC<HistoryCollectionProps> = (props: HistoryCollectionProps) => {
  const { historyCount, latestBitstrayId } = props;

  if (!latestBitstrayId) return null;

  const startAtZero = latestBitstrayId - BigInt(historyCount) < 0n;

  const bitstrayIds: Array<bigint | null> = new Array(historyCount).fill(null).map((_, i) => {
    if (BigInt(i) < latestBitstrayId) {
      const index = startAtZero ? 0n : latestBitstrayId - BigInt(historyCount);
      return index + BigInt(i);
    } else {
      return null;
    }
  });

  const bitstraysContent = bitstrayIds.map((bitstrayId, i) => {
    return !bitstrayId && bitstrayId !== 0n ? (
      <LoadingBitstray key={i} />
    ) : (
      <StandaloneBitstray key={i} bitstrayId={bitstrayId!} />
    );
  });

  return (
    <Section bgColor="white" fullWidth={true}>
      <Container fluid>
        <Row className="justify-content-md-center">
          <div className={clsx(classes.historyCollection)}>{config.app.enableHistory && bitstraysContent}</div>
        </Row>
      </Container>
    </Section>
  );
};

export default HistoryCollection;
